import React from 'react';
import { connect } from 'react-redux';

import { Breadcrumbs } from 'components/no-auth/common/breadcrumbs/Breadcrumbs';
import ColoredSectionContainer from 'components/no-auth/common/ColoredSectionContainer';
import { LightButton } from 'components/no-auth/common/fromAuth/LightButton/LightButton';
import { LightFixedBottomPanel } from 'components/no-auth/common/fromAuth/LightFixedBottomPanel/LightFixedBottomPanel';
import { PromoIcon } from 'components/no-auth/common/promo-icon/PromoIcon';
import { PromoPageContainer } from 'components/no-auth/common/promo-page-container/PromoPageContainer';
import { PromoText } from 'components/no-auth/common/promo-text/PromoText';
import { PromoRow } from 'components/no-auth/common/PromoRow/PromoRow';
import HeadingSection from 'components/no-auth/common/sections/HeadingSection';
import { ZendeskHelpLink } from 'components/no-auth/help/styles';
import ZendeskHelpSearch from 'components/no-auth/help/ZendeskHelpSearch';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';

import { toggleChat } from 'actions/chatAction';

import { getLangCountryPrefix } from 'helpers/utils';

const ZendeskHelpCategoryPage = (props) => {
    const category = props.category;

    const url = `${getLangCountryPrefix(props.lang, props.country)}/help`;

    const filteredSections = props.sections?.filter((section) => {
        return section.category_id === category?.id && !section.directLink;
    });

    const sections = filteredSections.map((item) => {
        return (
            <PromoRow indent="adaptive-24-32" key={item.id} lastChildNoMargin>
                <ZendeskHelpLink href={`${url}/category/${item.category_id}/section/${item.id}`}>
                    <PromoText variant="h4">{item.name}</PromoText>
                    <PromoIcon name="chevron-right" size="24px" />
                </ZendeskHelpLink>
            </PromoRow>
        );
    });

    const breadcrumbs = [{ name: 'Paysend', url: url }, { name: category?.name }];

    return (
        <PromoPageContainer hasTopPadding>
            <ColoredSectionContainer dimension="average" bottomPadding noTopPadding>
                <ZendeskHelpSearch />
                <Breadcrumbs breadcrumbsItems={breadcrumbs} />
                <HeadingSection title={category?.name} titleTag={'h1'} />
                <PromoRow indent="64px">{sections}</PromoRow>
            </ColoredSectionContainer>
            {props.showZendeskChat && (
                <LightFixedBottomPanel pressedAboveCookieButton>
                    <LightButton raised={true} caption={props.chatButton} onClick={() => props.toggleChat(true)} />
                </LightFixedBottomPanel>
            )}
        </PromoPageContainer>
    );
};

const mapStateToProps = ({ extra }) => ({
    category: extra?.zendeskHelpData?.category,
    sections: extra?.zendeskHelpData?.sections,
    lang: extra.noAuthFooter?.language?.lang,
    country: extra.noAuthFooter?.language?.country,
    chatButton: extra?.strapiApi?.chat_btn,
    showZendeskChat: extra?.noAuthFooter?.showZendeskChat,
});

export default connect(mapStateToProps, { toggleChat })(NotAuthBasePage(ZendeskHelpCategoryPage));
